// extracted by mini-css-extract-plugin
export var form = "_4r-0";